<template>
    <div
        class="gp-app-video pb-show-showVideos"
        :class="{'is-radius': isBorderRaduis,'is-left-right-radius': !isBorderRaduis}"
        :data-pblog="pblogData"
    >
        <img
            v-show="posterVisible || !(videoVisible && $root.$data.videoView[index])" v-lazy="poster"
            class="gp-app-video__poster"
        >
        <video
            id="video_one"
            ref="video"
            class="gp-app-video__video"
            :preload="gameUrl ? 'auto' : 'none'"
            :class="{'is-visible': videoVisible && $root.$data.videoView[index],
                     'is-visible-v': videoVisible && $root.$data.videoView[index] && isV,
                     'no-border': videoVisible && gameUrl}"
            :src="src"
            t7-video-player-type="inline"
            muted
            @error.prevent="videoError"
            @click="goGamePage"
        ></video>
        <div class="gp-app-video__control">
            <div
                v-if="paused || !$root.$data.videoView[index]" class="gp-app-video__play-area"
                @click="showAndPlay(true)"
            >
                <div class="gp-app-video__play-btn"></div>
            </div>
            <div
                v-else class="gp-app-video__control-bar"
                :class="{'no-border': !paused && gameUrl}"
            >
                <div
                    class="gp-app-video__pause-btn"
                    @click="pause(true)"
                ></div>
                <div
                    class="gp-app-video__mute" :class="{'is-muted': muted}"
                    @click="toggleMute"
                ></div>
            </div>
        </div>
        <div
            v-if="gameUrl && !paused" class="game-video-content"
            @click="goGamePage"
        ></div>
    </div>
</template>
<script>
import {on, off} from '@/utils/dom';
import {isIOS} from '@/utils/browser';
import api from '@/api';
import {getDeepValue} from '@/utils/utility';
import {debounce} from 'throttle-debounce';
// import {getQueryString, getUrlParams} from '@/utils/url';
export default {
    props: {
        poster: {
            type: String,
            required: true,
        },
        src: {
            type: String,
            required: true,
        },
        vid: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            required: true,
        },
        isV: {
            type: Boolean,
            required: false,
        },
        tab: {
            type: String,
            required: false,
        },
        item: {
            type: Object,
            required: false,
        },
        tabName: {
            type: String,
            required: false,
        },
        moduleName: {
            type: String,
            required: false,
            default: '',
        },
        source: {
            type: Number,
            required: false,
        },
        autoPlay: {
            type: Boolean,
            required: false,
        },
        isBorderRaduis: {
            type: Boolean,
            default: true,
        },
        playVideo: {
            type: Number,
            default: 1,
        },
        videoName: {
            type: String,
            required: false,
            default: '',
        },
        appName: {
            type: String,
            default: '',
        },
        appId: {
            type: String,
            default: '',
        },
        // 页游中心h5页面传来的顶部模块的gameUrl
        gameUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            posterVisible: true,
            paused: true,
            videoVisible: false,
            muted: false,
            lastStatus: {
                paused: true,
                videoVisible: false,
            },
            pblogData: {},
        };
    },
    computed: {
        isPlay: function () {
            return this.$root.$data.videoView[this.index];
        },
    },
    watch: {
        isPlay: function (val) {
            if (!val) {
                this.$refs.video.pause();
            }
        },
        playVideo() {
            if (!isIOS()) {
                this.showAndPlay();
            }
        },
    },
    mounted() {
        on(this.$refs.video, 'ended', () => {
            this.paused = true;
        });
        on(this.$refs.video, 'pause', () => {
            this.paused = true;
            if (isIOS()) {
                this.videoVisible = false;
            }
        });
        this.setDisplayLog();
        if (this.autoPlay && this.$wifi) {
            this.showAndPlay(true);
        }
        this.pageScrollFun = debounce(500, () => {
            this.pageScroll();
        });
        on(window, 'scroll', this.pageScrollFun);
        if (this.gameUrl) {
            this.$refs.video.setAttribute('playsinline', '');
            this.$refs.video.setAttribute('webkit-playsinline', '');
        }
    },
    destroyed() {
        off(window, 'scroll', this.pageScrollFun);
    },
    methods: {
        logPush(clk) {
            if (!this.item) {
                return;
            }

            let pblogData = JSON.stringify({
                value: '',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                videoPos: this.tab,
                                playNumber: this.item.pv,
                                videoId: this.item.id,
                                videoName: this.item.title,
                                tabName: this.tabName,
                                moduleName: this.moduleName,
                            }, this.$root.extData),
                            pos: this.index + 1,
                        },
                    ],
                },
            });

            const ext = getDeepValue(JSON.parse(pblogData), 'ext.item.0.ext');
            let content = {
                value: 'gameVideo',
                ext: {
                    id: '',
                    ext: {
                        clickState: this.tab && (clk ? 'start' : 'pause'),
                        clickType: clk ? 'play' : 'pause',
                        ...ext,
                    },
                    pos: this.index + 1,
                },
            };
            this.$logger.click(content);
        },
        showAndPlay() {
            if (this.source === 2) {
                location.href = this.src;
                return;
            }
            this.logPush(true);
            this.$root.$data.videoView = [];
            this.$root.$data.videoView[this.index] = true;
            this.show();
            this.play();
        },
        play() {
            this.$refs.video.play();
            this.posterVisible = false;
            this.paused = false;
            this.muted = this.$refs.video.muted;
        },
        pause() {
            // this.logPush(false);
            this.lastStatus.paused = this.paused;
            this.lastStatus.videoVisible = this.videoVisible;
            this.$refs.video.pause();
            this.paused = true;
        },
        toggleMute() {
            this.$refs.video.muted = !this.$refs.video.muted;
            this.muted = this.$refs.video.muted;
        },
        show() {
            this.videoVisible = true;
        },
        hide() {
            this.videoVisible = false;
        },
        restore() {
            if (!this.lastStatus.paused) {
                this.play();
            }
            if (this.lastStatus.videoVisible) {
                this.show();
            }
        },
        videoError(e) {
            let data = {
                app_name: this.appName + ',type:' + e.type,
                video_name: this.videoName,
                video_src: this.src,
                page_url: window.location.href,
            };
            api.zone.videoError({
                type: 20,
                appid: this.appId,
                url: this.vid,
                data: JSON.stringify(data),
            });
        },
        pageScroll() {
            if (!this.$refs.video) {
                return;
            }
            // 视频组件距离屏幕顶部的距离
            const clientTop = this.$refs.video.getBoundingClientRect().top;
            // 190-490为播放视频距离在窗口内的位置
            if (clientTop > 190 && clientTop < 490) {
                this.$emit('playVideoIndex', this.index);
                this.$root.$data.videoView[this.index] = true;
            }
        },
        goGamePage() {
            if (this.gameUrl) {
                window.location.href = this.gameUrl;
            }
        },
        setDisplayLog() {
            if (!this.item) {
                return;
            }
            this.pblogData = JSON.stringify({
                value: '',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                videoPos: this.tab,
                                playNumber: this.item.pv,
                                videoId: this.item.id,
                                videoName: this.item.title,
                                tabName: this.tabName,
                                moduleName: this.moduleName,
                            }, this.$root.extData),
                            pos: this.index + 1,
                        },
                    ],
                },
            });

        },
    },
};
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(app-video) {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;
        overflow: hidden;

        @include when(radius){
            border-radius: px2rem(39);
        }
        @include when(left-right-radius){
            border-bottom-left-radius: px2rem(36);
            border-bottom-right-radius: px2rem(36);
        }


        @include e(poster) {
            width: 100%;
            height: 100%;
            border-radius: 0;
        }

        @include e(video) {
            width: 0px;
            height: 0px;
            object-fit: fill;
            border-radius: 0;

            @include when(visible) {
                width: auto;
                height: 100%;
            }

            @include when(visible-v) {
                width: 100%;
                height: auto;
            }


        }

        @include e(control) {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            border-bottom-left-radius: px2rem(39);
            border-bottom-right-radius: px2rem(39);
        }
        @include e(play-area) {
            width: 100%;
            height: 100%;
        }
        @include e(play-btn) {
            width: px2rem(140);
            height: px2rem(140);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('~public/assets/imgs/play.png') no-repeat;
            background-size: contain;
        }

        @include e(control-bar) {
            width: 100%;
            height: px2rem(80);
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: center;
            border-bottom-left-radius: px2rem(39);
            border-bottom-right-radius: px2rem(39);
        }

        @include e(pause-btn) {
            width: px2rem(50);
            height: px2rem(40);
            margin: 0 px2rem(15) 0 px2rem(30);
            background: url('~public/assets/imgs/pause.png') no-repeat;
            background-size: cover;
        }

        @include e(mute) {
            width: px2rem(50);
            height: px2rem(50);
            margin: 0 px2rem(15);
            background: url('~public/assets/imgs/voice.png') no-repeat;
            background-size: cover;

            @include when(muted) {
                background: url('~public/assets/imgs/mute.png') no-repeat;
                background-size: cover;
            }
        }
        .no-border {
            border-radius: 0 !important;
        }
        .game-video-content {
            width: 1242px;
            height: 620px;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 1;
        }
    }

</style>
